<script>
import BookingListTabKey from '@/shared/constants/booking/BookingListTabKey'
import featureFlagMixin from '@/mixins/featureFlagMixin'

export default {
  name: 'BookingOptionsSheet',
  mixins: [featureFlagMixin],
  props: {
    value: { type: Boolean, default: false },
    currentTabName: { type: String, default: '' },
    isPastBooking: { type: Boolean, default: false },
    isUpcomingBooking: { type: Boolean, default: false },
    editBookingOptions: { type: Array, default: () => [] },
    isValidDuplicateStatus: { type: Boolean, default: false },
  },
  emits: ['input', 'feedback', 'cancelBooking'],
  computed: {
    showDuplicateOption() {
      return (
        this.selfServiceFeatureFlags.enableDuplicateBooking &&
        (this.currentTabName === BookingListTabKey.upcoming ||
          this.currentTabName === BookingListTabKey.past ||
          this.currentTabName === BookingListTabKey.all)
      )
    },
    showFeedbackOption() {
      return (
        this.currentTabName === BookingListTabKey.past ||
        (this.currentTabName === BookingListTabKey.all && this.isPastBooking)
      )
    },
    showCancelOption() {
      return (
        (this.currentTabName === BookingListTabKey.upcoming ||
          this.currentTabName === BookingListTabKey.all) &&
        this.isUpcomingBooking
      )
    },
  },
  methods: {
    handleOptionClick(option, disabled) {
      if (option && option.event && !disabled) {
        this.$emit(option.event)
      }
    },
  },
}
</script>

<template>
  <v-bottom-sheet v-model="value" persistent>
    <v-sheet class="pa-4 v-sheet-options">
      <!-- Drag handle -->
      <div class="drag-handler"></div>

      <!-- Header -->
      <div
        class="menu-header d-flex align-center justify-space-between mb-3 px-4"
      >
        <span class="text-subtitle-1 v-sheet-title font-weight-medium">{{
          $t('general.options')
        }}</span>
        <BaseButton
          class="iconButtons"
          icon="mdi-close"
          fab
          tertiary
          sm
          @click="$emit('input', false)"
        />
      </div>

      <!-- Options list -->
      <v-list dense>
        <v-list-item
          v-for="(option, index) in editBookingOptions"
          :key="'edit-' + index"
          :disabled="option.data.disabled"
          @click="
            handleOptionClick(option.interaction.value, option.data.disabled)
          "
        >
          <v-list-item-icon>
            <v-icon size="20">{{ option.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <span class="v-sheet-options" text>
              {{ option.text }}
            </span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="showDuplicateOption"
          :disabled="!isValidDuplicateStatus"
        >
          <v-list-item-icon>
            <v-icon size="20">mdi-content-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <span
              class="v-sheet-options"
              text
              @click="$emit('duplicateBooking')"
            >
              {{ $t('booking.duplicate') }}
            </span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="showFeedbackOption">
          <v-list-item-icon>
            <v-icon size="20">mdi-message-alert-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <span class="v-sheet-options" text @click="$emit('feedback')">
              {{ $t('feedback.provideFeedbackBtn') }}
            </span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="showCancelOption">
          <v-list-item-icon>
            <v-icon size="20">mdi-close-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <span class="v-sheet-options" text @click="$emit('cancelBooking')">
              {{ $t('booking.cancelBookingBtn') }}
            </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-bottom-sheet>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-row.scss';

.v-list-item--disabled {
  .v-sheet-options,
  .v-list-item__icon i {
    color: $color-disabled !important;
  }
}
</style>
